import React, { lazy } from "react";
import { Redirect } from "react-router-dom";
import AuthLayout from "../../layouts/Auth";
import ErrorLayout from "../../layouts/Error";
import DashboardAdminLayout from "../../layouts/DashboardAdmin";
import LoginCaris from "../../pages/LandingPage/LoginCaris/LoginCaris";
import PrivacyPolicy from "../../pages/LandingPage/PrivacyPolicy";
import {
  KonfigurasiAdminAktifitas,
  KonfigurasiAdminPajak,
  KonfigurasiAdminRoleUser,
  FormRole,
  KonfigurasiAdminSistem,
  KonfigurasiAdminTemplateNotifikasi,
  KonfigurasiAdminEmailNotification,
  KonfigurasiAdminUnclaimOpenPeriod,
  MasterAdminBank,
  MasterAdminBankTambah,
  MasterAdminBankUbah,
  MasterAdminPublisher,
  MasterAdminUser,
  MasterAdminEditUser,
  MasterAdminTambahUser,
  MasterAdminLagu,
  MasterAdminLaguEdit,
  MasterAdminLaguTambah,
  MasterAdminPencipta,
  MasterAdminPenciptaEdit,
  MasterAdminUserPencipta,
  MasterAdminUserPublisher,
  ManajemenWebAdmin,
  PreviewManajemenWebAdmin,
  Billing,
  BillingDetail,
  MasterAdminDsp,
  AdvanceComposer,
  FormAdvanceComposer,
  DetailAdvanceComposer,
  FormParameterPublisher,
  FormParameterDsp,
  ReportProcess,
} from "pages/Admin";

// =========== Composer Page page Views =============//

import {
  ProfilePencipta,
  PermintaanPembayaran,
  AjukanPembayaran,
  PenciptaReviewLagu,
  PenciptaDetailReviewLagu,
  DashboardPencipta,
  DetailLaguPencipta,
  KontrakListPencipta,
  KontrakListDetailPencipta,
  LoanPagePencipta,
  DetailLoanPencipta,
  PaymentPencipta,
  PenciptaDetailPayment,
  PaymentPenciptaMutation,
  PrintReportDashboard,
} from "pages/Pencipta";

// =========== Notification Page page Views =============//

import NotificationPage from "../../pages/NotificationPage";
import DetailNotification from "../../pages/NotificationPage/Detail";

// =========== Landing page Views =============//
import Home from "../../pages/LandingPage/Home/Home";

import Otp from "../../pages/LandingPage/Otp/Otp";
import TentangKamiView from "../../pages/LandingPage/TentangKami/TentangKami";
import EdukasiView from "../../pages/LandingPage/Edukasi/Edukasi";
import ViewBerita from "../../pages/LandingPage/Berita";
import BeritaDetailView from "../../pages/LandingPage/Berita/DetailBerita";
import DetailLagu from "../../pages/LandingPage/DetailLagu/DetailLagu";
// =========== End Landing page Views =============//

// =========== MPIS Route Views =============//
import NewPassword from "../../pages/LandingPage/NewPassword/NewPassword";
import ChangePassword from "../../pages/changePassword";
import InvitationPassword from "../../pages/InvitationPassword/InvitationPassword";
import RedirectPage from "../../pages/RedirectPage";

import NewsAds from "../../pages/Publisher/BeritaIklanPublisher";
import FormNewsAds from "../../pages/Publisher/BeritaIklanPublisher/FormNewsAds";
import PreviewNewsAds from "../../pages/Publisher/BeritaIklanPublisher/PreviewNewsAds";
import DetailNewsAds from "../../pages/Publisher/BeritaIklanPublisher/DetailNewsAds";

import DashboardPublisher from "../../pages/Publisher/Dashboard";
import PrintReportPage from "../../pages/Publisher/Dashboard/PrintReportPage";

import {
  PersonalisasiPublisher,
  CostType,
  PembayaranPublisher,
  OriginalPublisherPublisher,
  OriginalPublisherV2Publisher,
  AktifitasPublisher,
  InvoiceConf,
  ContractReminder,
  TambahCostType,
  EditCostType,
  ComposerCredential,
  SubReporting,
  DetailSubReporting,
  SubReportingApproval,
} from "pages/Publisher/KonfigurasiPublisher";

import {
  KontrakPublisher,
  DetailKontrakPublisher,
  KontrakPublisherTambah,
  KontrakOriginalPublisher,
  KontrakOriginalPublisherTambah,
  KontrakOriginalPublisherEdit,
  DetailKontrakOriginalPublisher,
  MainKontrakComposerTambah,
  MainKontrakComposerEdit,
  MainDetailKontrakComposer,
  RoyaltyTracking,
  DetailRoyaltyTracking,
} from "pages/Publisher";

import ProfilePublisher from "../../pages/Publisher/Profile";

import ComposerContract from "../../pages/Publisher/ComposerContract";
import ComposerContractAdd from "../../pages/Publisher/ComposerContract/AddContract";
import ComposerContractEdit from "../../pages/Publisher/ComposerContract/EditContract";
import ComposerContractDetail from "../../pages/Publisher/ComposerContract/ContractDetail";

import MasterPublisherPencipta from "../../pages/Publisher/Master/Pencipta";
import FormParameterComposer from "../../pages/Publisher/Master/Pencipta/FormParameterComposer";
import MasterPublisherPerformer from "../../pages/Publisher/Master/Performer";
import FormParameterPerformer from "../../pages/Publisher/Master/Performer/FormParameterPerformer";
import MasterPublisherUser from "../../pages/Publisher/Master/User";

import MasterPublisherTax from "../../pages/Publisher/Master/Tax";

import MasterPublisherLagu from "../../pages/Publisher/Master/Lagu";
import MasterPublisherLaguTambah from "../../pages/Publisher/Master/Lagu/FormParameterSong";
import MasterPublisherLaguEdit from "../../pages/Publisher/Master/Lagu/FormParameterSong";
import MasterPublisherDsp from "../../pages/Publisher/Master/Dsp";
import DetailDSP from "../../pages/Publisher/Master/Dsp/detail";
import FormParameterClient from "../../pages/Publisher/Master/Dsp/FormParameterClient";

import ReviewLagu from "../../pages/Publisher/ReviewLagu";
import DetailReviewLagu from "../../pages/Publisher/ReviewLagu/DetailReviewLagu";

import ManajemenWeb from "../../pages/Publisher/ManajemenWeb";
import PreviewAboutUs from "../../pages/Publisher/ManajemenWeb/PreviewAboutUs";

// =========== End of MPIS Route Views =============//

// =========== End of MPIS Route Views =============//

// =========== Routes ==================
import adminRoutes from "../adminRoutes";
import publisherRoutes from "../publisherRoutes";

import LoanPage from "../../pages/Publisher/LoanPage";
import DetailLoan from "../../pages/Publisher/LoanPage/DetailLoan";
// migrate Claim and Usage into Sales Invoice
import Invoice from "../../pages/Publisher/Invoice";
// Remove redudant component (Add and Edit Claim Usage, Detail Dalam dan Luar Negri)
import DetailInvoice from "../../pages/Publisher/Invoice/DetailInvoice";
import DetailInvoicePayment from "../../pages/Publisher/Invoice/DetailInvoicePayment";
import AddInvoice from "../../pages/Publisher/Invoice/AddInvoice";
import DetailClaimAndUsage from "../../pages/Publisher/ClaimAndUsage/DetailClaimAndUsage";
import EditInvoice from "../../pages/Publisher/Invoice/EditInvoice";
import TrendComposer from "../../pages/Publisher/Dashboard/TrendComposer";

import {
  AdvancedPageFinance,
  AddAdvancedFinance,
  DetailAdvancedFinance,
  PrintPdfAdvancedPage,
  PaymentPage,
  AddPayment,
  DetailPayment,
  PaymentMutation,
} from "pages/Finance";

import LoanPageFinance from "../../pages/Publisher/LoanPage";
import DetailLoanFinance from "../../pages/Publisher/LoanPage/DetailLoan";

import PrintReportReview from "../../pages/Publisher/ReviewLagu/PrintReportReview";

import SongClaim from "../../pages/Publisher/SongClaim";
import DetailSongClaim from "../../pages/Publisher/SongClaim/DetailSongClaim";
import PrintReportDetailReview from "../../pages/Publisher/ReviewLagu/DetailReviewLagu/PrintReportDetailReview";

import ReportView from "../../pages/Publisher/Report";
import DetailReportView from "../../pages/Publisher/Report/DetailReport";
import CostAllocation from "../../pages/Publisher/CostAllocation";
import DetailCostAllocation from "../../pages/Publisher/CostAllocation/DetailCostAllocation";

import MasterPublisherAgent from "../../pages/Publisher/Master/Agent";

import CreateTax from "../../pages/Publisher/Master/Tax/CreateTax";
import EditTax from "../../pages/Publisher/Master/Tax/EditTax";

import ClientClassification from "../../pages/Publisher/Master/ClientClassification";

import MasterGroup from "../../pages/Publisher/Master/Group";

import DownloadMonitoring from "../../pages/Publisher/DownloadMonitoring";
import DownloadCCID from "../../pages/Publisher/DownloadCCID";

import UploadMonitoring from "../../pages/Publisher/UploadMonitoring";
import DetailMonitor from "../../pages/Publisher/UploadMonitoring/DetailMonitor";
import ExchangesRate from "../../pages/Publisher/ExchangesRate";
import ViewExRate from "../../pages/Publisher/ExchangesRate/ViewExRate/ViewExRate";

import UploadData from "../../pages/Publisher/UploadData";
import DetailUpload from "../../pages/Publisher/UploadData/DetailUpload/DetailUpload";
import AddUpload from "../../pages/Publisher/UploadData/AddUpload/AddUpload";

import DoubleClaim from "../../pages/Publisher/SongClaim/DoubleClaim";
import OwnershipConflict from "../../pages/Publisher/SongClaim/OwnershipConflict";
import SongUnclaim from "../../pages/Publisher/SongClaim/SongUnclaim";
import UnclaimMonitoring from "../../pages/Publisher/SongClaim/UnclaimMonitoring";
import DetailUnclaimMonitoring from "../../pages/Publisher/SongClaim/UnclaimMonitoring/DetailUnclaimMonitoring";
import PotentialClaim from "../../pages/Publisher/PotentialClaim/PotentialClaim";
import PotentialClaimLog from "../../pages/Publisher/PotentialClaim/PotentialClaimLog";
import DetailPotentialClaimLog from "../../pages/Publisher/PotentialClaim/PotentialClaimLog/DetailPotentialClaimLog";
import ManageRole from "../../pages/LandingPage/ManageRole/ManageRole";
import ManageComposer from "../../pages/LandingPage/ManageComposer/ManageComposer";

import SubmitDSP from "../../pages/Publisher/SubmitDSP";
import Balance from "../../pages/Publisher/Transaction/Balance";
import DetailBalance from "../../pages/Publisher/Transaction/Balance/DetailBalance";
import ComposerInvoiceForm from "../../pages/Publisher/Transaction/ComposerInvoice/Components/FormComposerInvoice";
import AddPaymentComposerInvoice from "../../pages/Publisher/Transaction/ComposerInvoice/Payment";
import PaymentComposerInvoice from "../../pages/Publisher/Transaction/ComposerInvoice/Form/PaymentComposerInvoice";
import DetailSalesInvoice from "../../pages/Publisher/Transaction/SalesInvoice/DetailSalesInvoice";
import BalanceMutation from "../../pages/Publisher/Transaction/BalanceMutation";
import CWR from "../../pages/Publisher/CWR";
import DetailCWR from "../../pages/Publisher/CWR/DetailCWR";

// switch case
let routesUsed = [];
let roleUsed = "all";

switch (roleUsed) {
  case "admin":
    // code block
    routesUsed = adminRoutes;
    break;
  case "publisher":
    // code block
    routesUsed = publisherRoutes;
    break;
  default:
    // code block
    routesUsed = [
      {
        path: "/",
        exact: true,
        component: Home,
      },
      {
        path: "/home",
        exact: true,
        component: Home,
      },
      {
        path: "/redirect/:token",
        exact: true,
        component: RedirectPage,
      },
      {
        path: "/manage-role",
        exact: true,
        isAuth: false,
        component: ManageRole,
      },
      {
        path: "/manage-composer",
        exact: true,
        isAuth: false,
        component: ManageComposer,
      },
      {
        path: "/otp",
        exact: true,
        isAuth: false,
        component: Otp,
      },
      {
        path: "/login",
        exact: true,
        isAuth: false,
        component: LoginCaris,
      },
      {
        path: "/privacy-policy",
        exact: true,
        isAuth: false,
        component: PrivacyPolicy,
      },
      {
        path: "/new-password/:token",
        exact: true,
        component: NewPassword,
      },
      {
        path: "/invitation/password/:token",
        exact: true,
        isAuth: false,
        component: InvitationPassword,
      },
      {
        path: "/berita",
        exact: true,
        isAuth: false,
        component: ViewBerita,
      },
      {
        path: "/artikel/detail/:id",
        exact: true,
        isAuth: false,
        component: BeritaDetailView,
      },
      {
        path: "/detail-lagu",
        exact: true,
        isAuth: false,
        component: DetailLagu,
      },
      {
        path: "/edukasi",
        exact: true,
        isAuth: false,
        component: EdukasiView,
      },
      {
        path: "/tentang-kami",
        exact: true,
        isAuth: false,
        component: TentangKamiView,
      },
      {
        path: "/auth",
        component: AuthLayout,
        routes: [
          {
            path: "/auth/login",
            exact: true,
            component: lazy(() => import("../../views/Login")),
          },
          {
            path: "/auth/register",
            exact: true,
            component: lazy(() => import("../../views/Register")),
          },
          {
            component: () => <Redirect to="/errors/error-404" />,
          },
        ],
      },
      {
        path: "/errors",
        component: ErrorLayout,
        routes: [
          {
            path: "/errors/error-401",
            exact: true,
            component: lazy(() => import("../../views/Error401")),
          },
          {
            path: "/errors/error-404",
            exact: true,
            component: lazy(() => import("../../views/Error404")),
          },
          {
            path: "/errors/error-500",
            exact: true,
            component: lazy(() => import("../../views/Error500")),
          },
          {
            component: () => <Redirect to="/errors/error-404" />,
          },
        ],
      },
      {
        path: "/admin",
        component: DashboardAdminLayout,
        routes: [
          {
            path: "/admin/dashboard",
            exact: true,
            role: ["publisher"],
            component: () => <DashboardPublisher roles={["publisher"]} />,
          },
          {
            path: "/admin/cwr-engine",
            exact: true,
            component: CWR,
          },
          {
            path: "/admin/cwr-engine/:id",
            exact: true,
            component: DetailCWR,
          },
          {
            path: "/admin/song-claim",
            exact: true,
            component: SongClaim,
          },
          {
            path: "/admin/song-claim/:id",
            exact: true,
            component: DetailSongClaim,
          },
          {
            path: "/admin/publisher/song-unclaim",
            exact: true,
            component: SongUnclaim,
          },
          {
            path: "/admin/publisher/double-claim",
            exact: true,
            component: DoubleClaim,
          },
          {
            path: "/admin/publisher/ownership-conflict",
            exact: true,
            component: OwnershipConflict,
          },
          {
            path: "/admin/publisher/unclaim-monitoring",
            exact: true,
            component: UnclaimMonitoring,
          },
          {
            path: "/admin/publisher/unclaim-monitoring/:id",
            exact: true,
            component: DetailUnclaimMonitoring,
          },
          {
            path: "/admin/publisher/potential-claim",
            exact: true,
            component: PotentialClaim,
          },
          {
            path: "/admin/publisher/potential-claim-log",
            exact: true,
            component: PotentialClaimLog,
          },
          {
            path: "/admin/publisher/potential-claim-log/:id",
            exact: true,
            component: DetailPotentialClaimLog,
          },
          {
            path: "/admin/dashboard/print-report",
            exact: true,
            component: PrintReportPage,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/composer-trend",
            exact: true,
            component: TrendComposer,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/loan",
            exact: true,
            component: LoanPage,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/loan/:id",
            exact: true,
            component: DetailLoan,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/advance-composer",
            exact: true,
            component: AdvanceComposer,
          },
          {
            path: "/admin/advance-composer/detail/:id",
            exact: true,
            component: DetailAdvanceComposer,
          },
          {
            path: "/admin/advance-composer/add",
            exact: true,
            component: FormAdvanceComposer,
          },
          {
            path: "/admin/advance-composer/edit/:id",
            exact: true,
            component: FormAdvanceComposer,
          },
          {
            path: "/admin/advance",
            exact: true,
            component: AdvancedPageFinance,
          },

          {
            path: "/admin/advance/add",
            exact: true,
            component: AddAdvancedFinance,
          },
          {
            path: "/admin/advance/:id",
            exact: true,
            component: DetailAdvancedFinance,
          },
          {
            path: "/admin/balance",
            exact: true,
            component: Balance,
          },
          {
            path: "/admin/balance/:id",
            exact: true,
            component: DetailBalance,
          },
          {
            path: "/admin/balance-mutation",
            exact: true,
            component: BalanceMutation,
          },
          {
            path: "/admin/cost-allocation",
            exact: true,
            component: CostAllocation,
          },
          {
            path: "/admin/detail-cost-allocation/:id",
            exact: true,
            component: DetailCostAllocation,
          },
          {
            path: "/admin/payment",
            exact: true,
            component: PaymentPage,
          },
          {
            path: "/admin/payment/add",
            exact: true,
            component: AddPaymentComposerInvoice,
          },
          {
            path: "/admin/payment/:id",
            exact: true,
            component: DetailPayment,
          },
          {
            path: "/admin/payment-mutation",
            exact: true,
            component: PaymentMutation,
          },
          {
            path: "/admin/claim-and-usage",
            exact: true,
            component: Invoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/upload",
            exact: true,
            component: UploadData,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/add-upload/:id",
            exact: true,
            component: AddUpload,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/detail-upload/:id",
            exact: true,
            component: DetailUpload,
            role: ["publisher", "admin"],
          },

          {
            path: "/admin/upload-monitoring",
            exact: true,
            component: UploadMonitoring,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/download-dsrf",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/report-process",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/process-dsrf",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },

          {
            path: "/admin/dsrf/process-monitoring",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/potential-claim",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/potential-claim-matching",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/matching-2",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/dsrf-matching",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/dsrf/dsrf-matching-2",
            exact: true,
            component: ReportProcess,
            role: ["publisher", "admin"],
          },

          {
            path: "/admin/detail-upload-monitoring/:id",
            exact: true,
            component: DetailMonitor,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/claim-and-usage/add",
            exact: true,
            component: AddInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/claim-and-usage/:id",
            exact: true,
            component: DetailClaimAndUsage,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/claim-and-usage/edit/:id",
            exact: true,
            component: EditInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/profile",
            exact: true,
            component: ProfilePublisher,
            role: ["publisher", "admin"],
          },

          {
            path: "/admin/berita-publisher",
            exact: true,
            component: NewsAds,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/notifikasi",
            exact: true,
            component: NotificationPage,
          },
          {
            path: "/admin/notifikasi/:id",
            exact: true,
            component: DetailNotification,
          },
          {
            path: "/admin/berita-publisher/edit/preview",
            exact: true,
            component: PreviewNewsAds,
          },
          {
            path: "/admin/berita-publisher/edit/:id",
            exact: true,
            component: FormNewsAds,
          },
          {
            path: "/admin/berita-publisher/tambah",
            exact: true,
            component: FormNewsAds,
          },
          {
            path: "/admin/berita-publisher/tambah/preview",
            exact: true,
            component: PreviewNewsAds,
          },
          {
            path: "/admin/berita-publisher/:id",
            exact: true,
            component: DetailNewsAds,
          },
          {
            path: "/admin/master/tax",
            exact: true,
            component: MasterPublisherTax,
          },
          {
            path: "/admin/master/tax/tambah",
            exact: true,
            component: CreateTax,
          },

          {
            path: "/admin/master/tax/edit/:id",
            exact: true,
            component: EditTax,
          },
          {
            path: "/admin/composer-invoice/add",
            exact: true,
            component: ComposerInvoiceForm,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/composer-invoice/edit/:id",
            exact: true,
            component: ComposerInvoiceForm,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/composer-invoice/payment",
            exact: true,
            component: PaymentComposerInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/royalty-tracking",
            exact: true,
            component: RoyaltyTracking,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/royalty-tracking/:id",
            exact: true,
            component: DetailRoyaltyTracking,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/sales-invoice",
            exact: true,
            component: Invoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/sales-invoice/add",
            exact: true,
            component: AddInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/sales-invoice/:id",
            exact: true,
            component: DetailSalesInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/sales-invoice/edit/:id",
            exact: true,
            component: EditInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/composer-invoice",
            exact: true,
            component: Invoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/composer-invoice/:id",
            exact: true,
            component: DetailInvoice,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/composer-invoice/detail-payment/:id",
            exact: true,
            component: DetailInvoicePayment,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/master/pencipta",
            exact: true,
            component: MasterPublisherPencipta,
          },
          {
            path: "/admin/master/pencipta/tambah",
            exact: true,
            component: FormParameterComposer,
          },
          {
            path: "/admin/master/pencipta/edit/:id",
            exact: true,
            component: FormParameterComposer,
          },
          {
            path: "/admin/master/client-classification",
            exact: true,
            component: ClientClassification,
          },
          {
            path: "/admin/master/group",
            exact: true,
            component: MasterGroup,
          },
          {
            path: "/admin/master/lagu",
            exact: true,
            component: MasterPublisherLagu,
          },
          {
            path: "/admin/master/lagu/tambah",
            exact: true,
            component: MasterPublisherLaguTambah,
          },
          {
            path: "/admin/master/lagu/edit/:id",
            exact: true,
            component: MasterPublisherLaguEdit,
          },
          {
            path: "/admin/master/agent",
            exact: true,
            component: MasterPublisherAgent,
          },
          {
            path: "/admin/master/dsp",
            exact: true,
            component: MasterPublisherDsp,
          },
          {
            path: "/admin/master/client/add",
            exact: true,
            component: FormParameterClient,
          },
          {
            path: "/admin/master/client/edit/:id",
            exact: true,
            component: FormParameterClient,
          },
          {
            path: "/admin/master/dsp/detail/:id",
            exact: true,
            component: DetailDSP,
          },
          {
            path: "/admin/master/performer",
            exact: true,
            component: MasterPublisherPerformer,
          },
          {
            path: "/admin/master/performer/tambah",
            exact: true,
            component: FormParameterPerformer,
          },
          {
            path: "/admin/master/performer/ubah/:id",
            exact: true,
            component: FormParameterPerformer,
          },
          {
            path: "/admin/master/user",
            exact: true,
            component: MasterPublisherUser,
          },
          {
            path: "/admin/master/client-classification",
            exact: true,
            component: ClientClassification,
          },
          {
            path: "/admin/konfigurasi/personalisasi",
            exact: true,
            component: PersonalisasiPublisher,
          },
          {
            path: "/admin/konfigurasi/add-cost-type",
            exact: true,
            component: TambahCostType,
          },
          {
            path: "/admin/konfigurasi/edit-cost-type/:id",
            exact: true,
            component: EditCostType,
          },
          {
            path: "/admin/konfigurasi/cost-type",
            exact: true,
            component: CostType,
          },
          {
            path: "/admin/konfigurasi/composer-credential",
            exact: true,
            component: ComposerCredential,
          },
          {
            path: "/admin/konfigurasi/pembayaran",
            exact: true,
            component: PembayaranPublisher,
          },

          {
            path: "/admin/konfigurasi/invoice",
            exact: true,
            component: InvoiceConf,
          },
          {
            path: "/admin/konfigurasi/contract-reminder",
            exact: true,
            component: ContractReminder,
          },
          {
            path: "/admin/konfigurasi/original-publisher",
            exact: true,
            component: OriginalPublisherPublisher,
          },
          {
            path: "/admin/konfigurasi/original-publisher-v2",
            exact: true,
            component: OriginalPublisherV2Publisher,
          },
          {
            path: "/admin/konfigurasi/tax",
            exact: true,
            component: MasterPublisherTax,
          },
          {
            path: "/admin/konfigurasi/aktifitas",
            exact: true,
            component: AktifitasPublisher,
          },

          {
            path: "/admin/kontrak-publisher",
            exact: true,
            component: KontrakPublisher,
          },
          {
            path: "/admin/kontrak-publisher/detail/:id",
            exact: true,
            component: DetailKontrakPublisher,
          },
          {
            path: "/admin/kontrak-original-publisher",
            exact: true,
            component: KontrakOriginalPublisher,
          },
          {
            path: "/admin/kontrak-original-publisher/tambah",
            exact: true,
            component: KontrakOriginalPublisherTambah,
          },
          {
            path: "/admin/kontrak-original-publisher/edit/:id",
            exact: true,
            component: KontrakOriginalPublisherEdit,
          },
          {
            path: "/admin/kontrak-original-publisher/:id",
            exact: true,
            component: DetailKontrakOriginalPublisher,
          },
          {
            path: "/admin/kontrak/tambah",
            exact: true,
            component: KontrakPublisherTambah,
          },

          {
            path: "/admin/reports",
            exact: true,
            component: ReportView,
          },
          {
            path: "/admin/reports/:id",
            exact: true,
            component: DetailReportView,
          },

          {
            path: "/admin/kontrak-composer",
            exact: true,
            component: ComposerContract,
          },
          {
            path: "/admin/kontrak-composer/tambah",
            exact: true,
            component: ComposerContractAdd,
          },
          {
            path: "/admin/kontrak-composer/edit/:id",
            exact: true,
            component: ComposerContractEdit,
          },
          {
            path: "/admin/kontrak-composer/:id",
            exact: true,
            component: ComposerContractDetail,
          },

          {
            path: "/admin/kontrak-composer-main/tambah",
            exact: true,
            component: MainKontrakComposerTambah,
          },
          {
            path: "/admin/kontrak-composer-main/edit/:id",
            exact: true,
            component: MainKontrakComposerEdit,
          },
          {
            path: "/admin/kontrak-composer-main/:id",
            exact: true,
            component: MainDetailKontrakComposer,
          },
          {
            path: "/admin/review-lagu",
            exact: true,
            component: ReviewLagu,
          },
          {
            path: "/admin/review-lagu/print-report",
            exact: true,
            component: PrintReportReview,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/konfigurasi/sub-reporting",
            exact: true,
            component: SubReporting,
          },
          {
            path: "/admin/konfigurasi/sub-reporting/:id",
            exact: true,
            component: DetailSubReporting,
          },
          {
            path: "/admin/konfigurasi/sub-reporting-approval",
            exact: true,
            component: SubReportingApproval,
          },
          {
            path: "/admin/review-lagu/detail/print-report",
            exact: true,
            component: PrintReportDetailReview,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/review-lagu/:id",
            exact: true,
            component: DetailReviewLagu,
          },
          {
            path: "/admin/konfigurasi/exchange-rate",
            exact: true,
            component: ExchangesRate,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/konfigurasi/exchange-rate/view/:id/:currency",
            exact: true,
            component: ViewExRate,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/submitDSP",
            exact: true,
            component: SubmitDSP,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/change-password",
            exact: true,
            component: ChangePassword,
          },
          {
            path: "/admin/konfigurasi/sistem",
            exact: true,
            component: props => (
              <KonfigurasiAdminSistem {...props} mustLoggedIn={true} />
            ),
          },
          {
            path: "/admin/konfigurasi/unclaim-open-period",
            exact: true,
            component: props => (
              <KonfigurasiAdminUnclaimOpenPeriod
                {...props}
                mustLoggedIn={true}
              />
            ),
          },
          {
            path: "/admin/konfigurasi/template-notifikasi",
            exact: true,
            component: KonfigurasiAdminTemplateNotifikasi,
          },
          {
            path: "/admin/konfigurasi/pajak",
            exact: true,
            component: KonfigurasiAdminPajak,
          },
          {
            path: "/admin/konfigurasi/role-user",
            exact: true,
            component: KonfigurasiAdminRoleUser,
          },
          {
            path: "/admin/konfigurasi/role-user/tambah/:type",
            exact: true,
            component: FormRole,
          },
          {
            path: "/admin/konfigurasi/role-user/edit/:type/:role_id",
            exact: true,
            component: FormRole,
          },
          {
            path: "/admin/konfigurasi/aktifitas-admin",
            exact: true,
            component: KonfigurasiAdminAktifitas,
          },
          {
            path: "/admin/konfigurasi/system-email-notification",
            exact: true,
            component: KonfigurasiAdminEmailNotification,
          },
          // end admin konfigurasi
          {
            path: "/admin/master/publisher",
            exact: true,
            component: MasterAdminPublisher,
          },
          {
            path: "/admin/master/publisher/add",
            exact: true,
            component: FormParameterPublisher,
          },
          {
            path: "/admin/master/publisher/:id",
            exact: true,
            component: FormParameterPublisher,
          },
          {
            path: "/admin/master/lagu-admin",
            exact: true,
            component: MasterAdminLagu,
          },
          {
            path: "/admin/master/lagu-admin/tambah",
            exact: true,
            component: MasterAdminLaguTambah,
          },
          {
            path: "/admin/master/lagu-admin/edit/:id",
            exact: true,
            component: MasterAdminLaguEdit,
          },

          {
            path: "/admin/master/user-admin",
            exact: true,
            component: MasterAdminUser,
          },
          {
            path: "/admin/master/user-admin/tambah",
            exact: true,
            component: MasterAdminTambahUser,
          },
          {
            path: "/admin/master/user-admin/edit/:id",
            exact: true,
            component: MasterAdminEditUser,
          },
          {
            path: "/admin/master/bank-admin",
            exact: true,
            component: MasterAdminBank,
          },
          {
            path: "/admin/master/bank-admin/tambah",
            exact: true,
            component: MasterAdminBankTambah,
          },
          {
            path: "/admin/master/bank-admin/ubah/:id",
            exact: true,
            component: MasterAdminBankUbah,
          },
          {
            path: "/admin/master/pencipta-admin/:id",
            exact: true,
            component: MasterAdminPenciptaEdit,
          },
          {
            path: "/admin/master/pencipta-admin",
            exact: true,
            component: MasterAdminPencipta,
          },
          {
            path: "/admin/master/dsp-admin",
            exact: true,
            component: MasterAdminDsp,
          },
          {
            path: "/admin/master/dsp-admin/add",
            exact: true,
            component: FormParameterDsp,
          },
          {
            path: "/admin/master/dsp-admin/:id",
            exact: true,
            component: FormParameterDsp,
          },
          {
            path: "/admin/master/user-publisher",
            exact: true,
            component: MasterAdminUserPublisher,
          },
          {
            path: "/admin/master/user-pencipta",
            exact: true,
            component: MasterAdminUserPencipta,
          },
          {
            path: "/admin/berita",
            exact: true,
            component: NewsAds,
          },
          {
            path: "/admin/berita/tambah",
            exact: true,
            component: FormNewsAds,
          },
          {
            path: "/admin/berita/tambah/preview",
            exact: true,
            component: PreviewNewsAds,
          },
          {
            path: "/admin/berita/edit/preview",
            exact: true,
            component: PreviewNewsAds,
          },
          {
            path: "/admin/berita/:id",
            exact: true,
            component: FormNewsAds,
          },
          {
            path: "/admin/finalisasi-berita",
            exact: true,
            component: NewsAds,
          },
          {
            path: "/admin/finalisasi-berita/view/preview",
            exact: true,
            component: PreviewNewsAds,
          },
          {
            path: "/admin/finalisasi-berita/view/:id",
            exact: true,
            component: FormNewsAds,
          },
          {
            path: "/admin/manajemen-web",
            exact: true,
            component: ManajemenWeb,
          },
          {
            path: "/admin/manajemen-web/preview",
            exact: true,
            component: PreviewAboutUs,
          },
          {
            path: "/admin/manajemen-web-admin",
            exact: true,
            component: ManajemenWebAdmin,
          },
          {
            path: "/admin/manajemen-web/preview-admin",
            exact: true,
            component: PreviewManajemenWebAdmin,
          },
          {
            path: "/admin/download-monitoring",
            exact: true,
            component: DownloadMonitoring,
          },
          {
            path: "/admin/download-ccid",
            exact: true,
            component: DownloadCCID,
          },
          {
            path: "/admin/parameter/pencipta",
            exact: true,
            component: MasterPublisherPencipta,
          },
          {
            path: "/admin/parameter/pencipta/tambah",
            exact: true,
            component: FormParameterComposer,
          },
          {
            path: "/admin/parameter/pencipta/edit/:id",
            exact: true,
            component: FormParameterComposer,
          },
          {
            path: "/admin/parameter/client-classification",
            exact: true,
            component: ClientClassification,
          },
          {
            path: "/admin/parameter/group",
            exact: true,
            component: MasterGroup,
          },
          {
            path: "/admin/billing/publisher",
            exact: true,
            component: Billing,
            role: ["publisher", "admin"],
          },
          {
            path: "/admin/billing/detail/:id",
            exact: true,
            component: BillingDetail,
          },
          {
            path: "/admin/parameter/lagu",
            exact: true,
            component: MasterPublisherLagu,
          },
          {
            path: "/admin/parameter/lagu/tambah",
            exact: true,
            component: MasterPublisherLaguTambah,
          },
          {
            path: "/admin/parameter/lagu/edit/:id",
            exact: true,
            component: MasterPublisherLaguEdit,
          },

          {
            path: "/admin/parameter/agent",
            exact: true,
            component: MasterPublisherAgent,
          },
          {
            path: "/admin/parameter/dsp",
            exact: true,
            component: MasterPublisherDsp,
          },
          {
            path: "/admin/parameter/client/add",
            exact: true,
            component: FormParameterClient,
          },
          {
            path: "/admin/parameter/client/edit/:id",
            exact: true,
            component: FormParameterClient,
          },
          {
            path: "/admin/parameter/dsp/detail/:id",
            exact: true,
            component: DetailDSP,
          },
          {
            path: "/admin/parameter/performer",
            exact: true,
            component: MasterPublisherPerformer,
          },
          {
            path: "/admin/parameter/performer/tambah",
            exact: true,
            component: FormParameterPerformer,
          },
          {
            path: "/admin/parameter/performer/edit/:id",
            exact: true,
            component: FormParameterPerformer,
          },
          {
            path: "/admin/parameter/user",
            exact: true,
            component: MasterPublisherUser,
          },
          // end mpis admin ==============================================
        ],
      },
      {
        path: "/finance",
        component: DashboardAdminLayout,
        routes: [
          {
            path: "/finance/advance",
            exact: true,
            component: AdvancedPageFinance,
          },
          {
            path: "/finance/advance/add",
            exact: true,
            component: AddAdvancedFinance,
          },
          {
            path: "/finance/advanced/print-as-pdf/:id",
            exact: true,
            component: PrintPdfAdvancedPage,
          },
          {
            path: "/finance/advance/:id",
            exact: true,
            component: DetailAdvancedFinance,
          },
          {
            path: "/finance/payment",
            exact: true,
            component: PaymentPage,
          },
          {
            path: "/finance/payment/add",
            exact: true,
            component: AddPayment,
          },
          {
            path: "/finance/payment/:id",
            exact: true,
            component: DetailPayment,
          },
          {
            path: "/finance/loan",
            exact: true,
            component: LoanPageFinance,
          },
          {
            path: "/finance/loan/:id",
            exact: true,
            component: DetailLoanFinance,
          },
        ],
      },
      //role pencipta
      {
        path: "/pencipta",
        component: DashboardAdminLayout,
        routes: [
          {
            path: "/pencipta/dashboard-pencipta",
            exact: true,
            component: () => <DashboardPencipta roles={["composer"]} />,
          },
          {
            path: "/pencipta/dashboard-pencipta/print-report",
            exact: true,
            component: () => <PrintReportDashboard />,
          },
          {
            path: "/pencipta/dashboard-pencipta/detail-lagu/:id",
            exact: true,
            role: ["composer"],
            component: DetailLaguPencipta,
          },
          {
            path: "/pencipta/kontrak",
            exact: true,
            role: ["pencipta"],
            component: KontrakListPencipta,
          },
          {
            path: "/pencipta/kontrak/detail-kontrak/:id/:songId",
            exact: true,
            component: KontrakListDetailPencipta,
          },
          {
            path: "/pencipta/payment",
            exact: true,
            role: ["pencipta"],
            component: PaymentPencipta,
          },
          {
            path: "/pencipta/payment-mutation",
            exact: true,
            role: ["pencipta"],
            component: PaymentPenciptaMutation,
          },
          {
            path: "/pencipta/payment/:id",
            exact: true,
            component: PenciptaDetailPayment,
          },
          {
            path: "/pencipta/loan",
            exact: true,
            component: LoanPagePencipta,
          },
          {
            path: "/pencipta/loan/:id",
            exact: true,
            component: DetailLoanPencipta,
          },
          {
            path: "/pencipta/permintaan-pembayaran",
            exact: true,
            component: PermintaanPembayaran,
          },
          {
            path: "/pencipta/permintaan-pembayaran/ajukan-pembayaran",
            exact: true,
            component: AjukanPembayaran,
          },
          {
            path: "/pencipta/profile-pencipta",
            exact: true,
            component: ProfilePencipta,
            role: ["publisher", "admin", "composer"],
          },
          {
            path: "/pencipta/review-lagu",
            exact: true,
            component: PenciptaReviewLagu,
          },
          {
            path: "/pencipta/review-lagu/print-report",
            exact: true,
            component: PrintReportReview,
            role: ["publisher", "admin"],
          },
          {
            path: "/pencipta/review-lagu/:id",
            exact: true,
            component: PenciptaDetailReviewLagu,
          },
        ],
      },
      {
        component: () => <Redirect to="/errors/error-404" />,
      },
    ];
}

const itemRoutes = routesUsed;

export default itemRoutes;
